import { render, staticRenderFns } from "./StateCoveragesForm.vue?vue&type=template&id=c4a8be78&scoped=true"
import script from "./StateCoveragesForm.vue?vue&type=script&lang=js"
export * from "./StateCoveragesForm.vue?vue&type=script&lang=js"
import style0 from "./StateCoveragesForm.vue?vue&type=style&index=0&id=c4a8be78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a8be78",
  null
  
)

export default component.exports